document.addEventListener('DOMContentLoaded', () => {
  const timers = document.querySelectorAll('.countdown__container [data-end-date]');

  if (!timers) return;

  timers.forEach(timer => {
    const enddate = timer.dataset.endDate * 1000;
    let x = setInterval(() => {

      // Get today's date and time
      let now = new Date();

      var delta = Math.abs(enddate - now) / 1000;
      var days = Math.floor(delta / 86400);
      delta -= days * 86400;

      // calculate (and subtract) whole hours
      var hours = Math.floor(delta / 3600) % 24;
      delta -= hours * 3600;

      // calculate (and subtract) whole minutes
      var minutes = Math.floor(delta / 60) % 60;
      delta -= minutes * 60;

      var seconds = Math.floor(delta);

      if (days < 10) days = '0' + days;
      if (hours < 10) hours = '0' + hours;
      if (minutes < 10) minutes = '0' + minutes;
      if (seconds < 10) seconds = '0' + seconds;

      const countdownTexts = document.querySelectorAll('.countdown__container_text')
      countdownTexts.forEach(text => text.innerText = `${days > 0 ? days + 'd : ' : ''}${hours}h : ${minutes}m : ${seconds}s`);

      if (Math.floor(delta) == 0 && parseInt(minutes) == 0 && parseInt(hours) == 0 && parseInt(days) == 0) {
        clearInterval(x);
        timer.closest('.promo_banner').remove();
      }
    }, 1000);
  });

});
